<script lang="ts">
  import { css, cx } from '@agapi/ui/panda/css';
  import { cardStyles } from '../card.styles';
  import type { CardContentProps } from '../card.types';

  const { css: cssProp, children, ...props }: CardContentProps = $props();

  const classes = cardStyles()
</script>

<div class={cx(classes.content, css(cssProp))} {...props}>
  {@render children?.()}
</div>
